import { useState } from "react";
import Head from "next/head";

import config from "config";
import { AuthLayout } from "auth";

import ButtonSwitch from "ui-components/Button-Switch";

import ProjectListing from "modules/projects/views/Project-Listing";
import DataFileListing from "modules/data-files/views/Listing";

const OPTIONS: {
  key: "projects" | "data";
  label: React.ReactNode;
}[] = [
  {
    key: "projects",
    label: <span className="uppercase font-semibold">Projects</span>,
  },
  {
    key: "data",
    label: <span className="uppercase font-semibold">Data Files</span>,
  },
];

const Projects = () => {
  const [view, setView] = useState<"projects" | "data">("projects");

  return (
    <div>
      <Head>
        <title>{config.SITE_NAME} | Existing Analysis</title>
      </Head>
      <div className="flex justify-center pb-4 mb-4">
        <ButtonSwitch options={OPTIONS} current={view} onClick={setView} />
      </div>
      {view === "projects" && <ProjectListing />}
      {view === "data" && <DataFileListing />}
    </div>
  );
};

Projects.getLayout = (page) => (
  <AuthLayout stopExpiredUsers={false}>{page}</AuthLayout>
);

export default Projects;
